import { SanityComparisonTable } from '#/lib/sanity/queries/comparisonTableSection';

import { DesktopTable } from './DesktopTable';
import { MobileAccordion } from './MobileAccordion';

export const ComparisonTable = (props: SanityComparisonTable) => {
  return (
    <section className="bg-grayscale-01 rounded-35 p-main md:pt-80 md:pb-140 py-40">
      <div className="max-w-1115 mx-auto">
        <h2 className="text-32 m:text-50 text-charcoal font-[440] mx-auto  leading-100 text-balance m:text-wrap  text-center mb-40 md:mb-90">
          {props.title}
        </h2>
        <DesktopTable {...props} />
        <MobileAccordion {...props} />
      </div>
    </section>
  );
};
